/* Help assistant: buttons, keyword answers and product search. No AI, no server. */
(function () {
  'use strict';
  var doc = document;
  var root = doc.querySelector('[data-help]');
  if (!root) return;
  var data;
  try { data = JSON.parse(doc.querySelector('[data-help-data]').textContent); } catch (e) { return; }

  var fab = root.querySelector('[data-help-toggle]');
  var panel = root.querySelector('[data-help-panel]');
  var log = root.querySelector('[data-help-log]');
  var chips = root.querySelector('[data-help-chips]');
  var form = root.querySelector('[data-help-form]');
  var input = root.querySelector('[data-help-input]');
  var started = false;

  /* on product pages a sticky add-to-cart bar slides up from the bottom: lift the button only while it shows */
  var sticky = doc.querySelector('[data-sticky-atc]');
  if (sticky && window.MutationObserver) {
    var syncSticky = function () { doc.documentElement.classList.toggle('has-sticky-atc', sticky.classList.contains('is-visible')); };
    new MutationObserver(syncSticky).observe(sticky, { attributes: true, attributeFilter: ['class'] });
    syncSticky();
  }

  var MAIN = [
    { label: 'Shipping', key: 'shipping' },
    { label: 'Returns', key: 'returns' },
    { label: 'Sizing', key: 'sizing' },
    { label: 'Track my order', key: 'tracking' },
    { label: 'Find a slogan', key: 'find' },
    { label: 'Talk to a human', key: 'human' }
  ];
  var IDEAS = [
    { label: 'Couples', key: 'q:couples' },
    { label: 'Drinking', key: 'q:drinking' },
    { label: 'Dating', key: 'q:dating' },
    { label: 'Sarcasm', key: 'q:sarcasm' },
    { label: 'Gifts', key: 'q:gift' },
    { label: 'Back', key: 'menu' }
  ];
  var RULES = [
    ['human', /\b(human|person|agent|someone|whatsapp|email|e-mail|contact|support|call|talk)\b/],
    ['tracking', /\b(track|tracking|where is|where's|order status|parcel|package|delivered|hasn'?t arrived)\b/],
    ['returns', /\b(return|refund|exchange|money back|send (it )?back|wrong size)\b/],
    ['shipping', /\b(ship|shipping|deliver|delivery|postage|how long|arrive|customs|duty|duties)\b/],
    ['sizing', /\b(size|sizing|fit|fits|large|small|medium|xl|xxl|chest|tall|oversized?|baggy|measurements?)\b/]
  ];

  function el(tag, cls, text) {
    var n = doc.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }
  function toEnd() {
    log.scrollTop = log.scrollHeight;
    /* the chip row can change height after this, which shrinks the log: scroll again next frame */
    window.requestAnimationFrame(function () { log.scrollTop = log.scrollHeight; });
  }
  function say(role, text) {
    var m = el('div', 'hc__msg hc__msg--' + role);
    m.appendChild(el('p', null, text));
    log.appendChild(m);
    toEnd();
    return m;
  }
  function addLinks(msg, list) {
    var wrap = el('div', 'hc__links');
    list.forEach(function (l) {
      var a = el('a', 'hc__link' + (l.ghost ? ' hc__link--ghost' : ''), l.label);
      a.href = l.href;
      if (l.ext) { a.target = '_blank'; a.rel = 'noopener'; }
      wrap.appendChild(a);
    });
    msg.appendChild(wrap);
    toEnd();
  }
  function setChips(list) {
    chips.textContent = '';
    list.forEach(function (c) {
      var b = el('button', 'hc__chip', c.label);
      b.type = 'button';
      b.addEventListener('click', function () { if (c.key === 'menu') { say('user', c.label); respond('menu'); } else { say('user', c.label); respond(c.key); } });
      chips.appendChild(b);
    });
    toEnd();
  }
  function humanLinks() {
    var out = [];
    if (data.whatsapp) out.push({ label: 'WhatsApp', href: 'https://wa.me/' + data.whatsapp, ext: true });
    if (data.email) out.push({ label: 'Email us', href: 'mailto:' + data.email, ghost: true });
    return out;
  }

  function money(price) {
    var n = parseFloat(price);
    if (isNaN(n)) return price || '';
    var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: cur }).format(n); } catch (e) { return String(n); }
  }
  function thumb(url) { return url ? url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=120' : ''; }

  function search(q) {
    var wait = say('bot', 'Looking…');
    wait.classList.add('hc__typing');
    var url = data.suggestUrl + '?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=4&resources[options][unavailable_products]=last';
    fetch(url, { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(new Error('search')); })
      .then(function (j) {
        var list = (j && j.resources && j.resources.results && j.resources.results.products) || [];
        if (wait.parentNode) wait.parentNode.removeChild(wait);
        if (!list.length) {
          var none = say('bot', 'Nothing for "' + q + '" yet. Try another word, or browse everything.');
          addLinks(none, [{ label: 'See all shirts', href: data.allUrl }]);
          setChips(IDEAS);
          return;
        }
        var m = say('bot', 'These might be you:');
        var grid = el('div', 'hc__prods');
        list.forEach(function (p) {
          var a = el('a', 'hc__prod');
          a.href = p.url;
          var img = el('img');
          var src = p.featured_image && p.featured_image.url;
          if (src) { img.src = thumb(src); img.alt = ''; img.width = 56; img.height = 56; img.loading = 'lazy'; a.appendChild(img); } else { a.appendChild(el('span')); }
          var box = el('span');
          box.appendChild(el('span', 'hc__prod-name', p.title));
          box.appendChild(el('span', 'hc__prod-price', money(p.price)));
          a.appendChild(box);
          grid.appendChild(a);
        });
        m.appendChild(grid);
        addLinks(m, [{ label: 'See all shirts', href: data.allUrl, ghost: true }]);
        setChips(IDEAS);
      })
      .catch(function () {
        if (wait.parentNode) wait.parentNode.removeChild(wait);
        var m = say('bot', data.fallback);
        addLinks(m, humanLinks());
        setChips(MAIN);
      });
  }

  function respond(key) {
    var m;
    if (key === 'menu') { say('bot', 'What else can I help with?'); setChips(MAIN); return; }
    if (key.indexOf('q:') === 0) { search(key.slice(2)); return; }
    if (key === 'shipping' || key === 'sizing') { say('bot', data[key]); setChips(MAIN); return; }
    if (key === 'returns') {
      m = say('bot', data.returns);
      if (data.refundUrl) addLinks(m, [{ label: 'Return policy', href: data.refundUrl }]);
      setChips(MAIN); return;
    }
    if (key === 'tracking') {
      m = say('bot', data.tracking);
      if (data.trackUrl) addLinks(m, [{ label: 'Track your order', href: data.trackUrl }]);
      setChips(MAIN); return;
    }
    if (key === 'find') { say('bot', 'What kind of slogan? Pick one, or type a word like "boyfriend" or "coffee".'); setChips(IDEAS); return; }
    if (key === 'human') {
      var links = humanLinks();
      m = say('bot', links.length ? 'Real people, real replies. Pick whatever is easiest:' : data.fallback);
      if (links.length) addLinks(m, links);
      setChips(MAIN); return;
    }
    m = say('bot', data.fallback);
    addLinks(m, humanLinks());
    setChips(MAIN);
  }

  function classify(text) {
    var t = text.toLowerCase();
    for (var i = 0; i < RULES.length; i++) { if (RULES[i][1].test(t)) return RULES[i][0]; }
    return null;
  }

  function start() {
    if (started) return;
    started = true;
    say('bot', data.greeting);
    setChips(MAIN);
  }
  function open() {
    start();
    panel.hidden = false;
    root.setAttribute('data-open', '');
    fab.setAttribute('aria-expanded', 'true');
    window.setTimeout(function () { input.focus({ preventScroll: true }); toEnd(); }, 40);
  }
  function close() {
    panel.hidden = true;
    root.removeAttribute('data-open');
    fab.setAttribute('aria-expanded', 'false');
    try { fab.focus({ preventScroll: true }); } catch (e) { /* ignore */ }
  }

  fab.addEventListener('click', open);
  root.querySelector('[data-help-close]').addEventListener('click', close);
  doc.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !panel.hidden && panel.contains(doc.activeElement)) close(); });
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var text = input.value.replace(/\s+/g, ' ').trim();
    if (!text) return;
    input.value = '';
    say('user', text);
    var key = classify(text);
    if (key) respond(key); else search(text);
  });
})();
